import { InputAdornment, Typography } from "@mui/material";
import { CoreAutocomplete, CoreTextField } from "@verity/components/core";
import { CaretDownIcon } from "../assets";

type SingleAutocompleteOnChange = (event: React.SyntheticEvent, value: string[]) => void;

type FormMultiAutoCompleteProps = {
	required?: boolean;
	title: string;
	placeholder: string;
	value: string[] | undefined;
	onChange: SingleAutocompleteOnChange;
	options: string[];
	startIcon?: React.ReactNode;
	error?: string;
	className?: string;
};

export function FormMultiAutoComplete({
	required = false,
	title,
	placeholder,
	value,
	onChange,
	options,
	error,
	className = "",
	startIcon = null,
}: FormMultiAutoCompleteProps) {
	return (
		<>
			<Typography>
				{title}
				{required && <span> *</span>}
			</Typography>
			<CoreAutocomplete
				style={{ flexShrink: 1 }}
				className={className}
				multiple
				popupIcon={<CaretDownIcon />}
				clearIcon={null}
				value={value}
				onChange={onChange}
				options={options}
				renderInput={(params) => (
					<CoreTextField
						placeholder={value?.length === 0 ? placeholder : ""}
						{...params}
						className={className}
						InputProps={{
							...params.InputProps,
							...(startIcon && { startAdornment: <InputAdornment position="start">{startIcon}</InputAdornment> }),
						}}
						error={error}
					/>
				)}
			/>
		</>
	);
}
